import React, { Component } from 'react'
import { connect } from 'react-redux'
import FlipMove from 'react-flip-move'

import isEqual from 'react-fast-compare'

import LoadMore from 'components/load-more/load-more'

import {
	createOrReturnChat,
	openModal,
	refreshUserData,
	handleSeen
} from 'state/actions'

import AlertBanner from 'components/alerts/alert-banner'

import MessageChat from './message-chat'
import Icon from 'components/icon/icon'

import {
	getLastUnreadItem,
	getLastChatItem,
	getChatObjects,
	getCurrentAccount,
	getCurrentUser
} from 'state/selectors'

import {
	isMobile,
} from 'utils'

import MobileFooterButtons from 'components/mobile/footer-buttons'

class Messages extends Component {
	state = {
		lastRenderedIndex: 1,
		emptyCellHeight: 0,
		maxVisibleItems: 10
	}

	tileRefs = []
	listRef = null
	cellHeight = 0

	shouldComponentUpdate = (nextProps, nextState) => {
		return !isEqual(this.props.processedChatData.chats, nextProps.processedChatData.chats) || !isEqual(this.state, nextState) || this.props.currentBigChatId !== nextProps.currentBigChatId
	}

	componentDidMount() {
		this.element = document.getElementById("message-list")

		this.element.addEventListener('touchmove', e => {
			this.props.handleTouchMove(e, 'move')
		}, {
			passive: false
		})

		this.element.addEventListener('touchstart', e => {
			this.props.handleTouchMove(e, 'start')
		}, {
			passive: false
		})

		this.setBigChatIfNone()
	}

	componentWillUnmount() {
		this.element.removeEventListener('touchmove', e => {
			this.props.handleTouchMove(e, 'move')
		})
		this.element.removeEventListener('touchstart', e => {
			this.props.handleTouchMove(e, 'start')
		})
	}

	componentDidUpdate = () => {
		this.setBigChatIfNone()
	}

	setBigChatIfNone = () => {
		const {
			currentBigChatId,
			processedChatData,
			createOrReturnChat,
			setCurrentBigChat
		} = this.props

		if (setCurrentBigChat && processedChatData && processedChatData.chats && processedChatData.chats.length && !currentBigChatId) {
			const firstChatObject = processedChatData.chats[0].chatObject

			setCurrentBigChat(firstChatObject.id)
			createOrReturnChat(firstChatObject)
		}
	}

	updateState = state => {
		this.setState(state)
	}

	createOrReturnChat = chat => {
		const {
			isBigChatOpen,
			createOrReturnChat,
			setCurrentBigChat,
			closeCallback,
			accountData
		} = this.props

		createOrReturnChat(chat, null, newChat => {
			if (setCurrentBigChat) {
				if (newChat) {
					setCurrentBigChat(newChat.id)
				}
			} else {
				if (isBigChatOpen) {
					const chatId = (newChat && newChat.id) ? newChat.id : chat.id

					window.open(`/${accountData.slug}/chat?id=${chatId}`, 'hasslChat')
				}
			}

			if (!isMobile()) {
				closeCallback()
			}
		})
	}

	deleteChat = chat => {
		this.props.openModal('delete', 'chat', { chat })
	}

	getLastItem = chatObject => {
		return getLastChatItem(chatObject, this.props.entities)
	}

	handleSeenAll = _ => {
		const {
			chats
		} = this.props.processedChatData

		chats.forEach(chat => {
			let lastUnreadItem = getLastUnreadItem(chat.chatObject, this.props.userData, this.props.entities)

			if (lastUnreadItem) {
				this.props.handleSeen(getLastUnreadItem(), this.props.userData)
			}
		})
	}

	loadMore = _ => {
		const {
			maxVisibleItems
		} = this.state

		this.setState({
			maxVisibleItems: (maxVisibleItems + 10)
		})
	}

	maximiseChats = () => {
		const { accountData } = this.props

		window.open(`/${accountData.slug}/chat`, 'hasslChat')
	}

	render() {
		const {
			userData,
			entities,
			processedChatData,
			accountData,
			tabName,
			setCurrentBigChat,
			currentBigChatId
		} = this.props

		const {
			emptyCellHeight,
			maxVisibleItems
		} = this.state

		const {
			chats,
			hasUnseenItems
		} = processedChatData

		if(userData?.id === 6529){
			console.log('stats for Tony')
			console.log(userData)
			console.log(processedChatData)
		}

		const mobileButtonProps = [
			{
				icon: 'fe-mail',
				label: 'New chat',
				callback: _ => { this.createOrReturnChat(null) },
				level: 'high',
			}, {
				icon: 'envelope',
				label: 'Mark all as read',
				callback: _ => {
					this.handleSeenAll()
				},
				disabled: !hasUnseenItems,
				level: 'low'
			}
		]

		const slicedChats = chats.slice(0, maxVisibleItems)

		return (
			<div>
				<MobileFooterButtons buttons={mobileButtonProps} />
				<h3 className="no-border">
					{tabName}
					<div className="header-tab-controls">
						{!setCurrentBigChat ?
							<button
								className={'active header-button high maximise'}
								onClick={this.maximiseChats}
							>
								<Icon name={'fe-maximize-2'} />
								<span>
									Pop out
								</span>
							</button>
							: null}
						<button className={'active header-button high'} onClick={_ => { this.createOrReturnChat(null) }}>
							<span>
								New chat
							</span>
						</button>
					</div>
				</h3>
				<div
					className="header-tab headertab-list-container"
					ref="listContainer"
					onScroll={e => {
						this.props.handleScroll(this.refs.listContainer.scrollTop, e)
					}}
					id="message-list"
				>
					{
						slicedChats.length ?
							<ul
								className="headertab-list"
								ref={ref => this.listRef = ref}
							>
								<FlipMove
									duration={250}
									easing="ease-out"
									enterAnimation="accordionVertical"
									leaveAnimation="accordionVertical"
								>
									{
										slicedChats.map(({
											chatObject,
											lastItem,
											lastUnreadItem
										}, index) => {
											return (
												<MessageChat
													chatObject={chatObject}
													key={chatObject.id}
													lastItem={lastItem}
													lastUnreadItem={lastUnreadItem}
													createOrReturnChat={this.createOrReturnChat}
													deleteChat={this.deleteChat}
													userData={userData}
													entities={entities}
													getRef={ref => {
														this.tileRefs[index] = ref
													}}
													shouldRender={true}
													cellHeight={emptyCellHeight}
													setCurrentBigChat={setCurrentBigChat}
													isCurrentBigChat={currentBigChatId === chatObject.id}
												/>
											)
										})
									}
								</FlipMove>
								<LoadMore
									isLoading={false}
									canLoadMore={chats.length > slicedChats.length}
									onClick={this.loadMore}
									type="chats"
								/>
							</ul>
							:
							<AlertBanner
								title={"No chats yet, I'm afraid."}
								body={accountData.users.length > 1 ? `Click 'New chat' to start a chat.` : "Invite some staff to chat with them."}
							/>
					}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		entities: state.account.entities,
		processedChatData: getChatObjects(state, ownProps),
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
		isBigChatOpen: state.auth.isBigChatOpen
	}
}

export default connect(mapStateToProps, {
	createOrReturnChat,
	openModal,
	refreshUserData,
	handleSeen
})(Messages)